<template>
  <header class="header d-flex flex-column justify-content-between pb-5">
    <TopHeader></TopHeader>
    <section class="logo-header-resp d-md-none my-5">
      <div class="mx-auto">     
         <div class="logo-header ml-4"><img v-if="homeData" :src="'http://api.infinity-align.com/storage/'+homeData.settings.site_logo" :alt="homeData.settings.site_title"></div>
</div>
    </section>
    <section v-if="homeData" class="header-content container text-right">
      <div>
        <h6 class="header-title fontsize-h3 text-md-right text-center mb-md-4 d-md-block d-none">{{homeData.settings.mainpage_title}}</h6>
        <p class="colorWhite fontsize-small text-color-theme text-justify weight-light line-height2-5 d-md-block d-none" :class="{'moveToTop':homeData.settings.site_body.length>768}"><span>{{homeData.settings.site_body}} </span> </p>
        <p class="mainText fontsize-small text-color-black text-center weight-light line-height2-5 d-md-none"  :class="{'moveToTop':homeData.settings.site_body.length>768}"><span>{{homeData.settings.site_body}} </span>
        </p>
        <div class="header-content-btn my-md-5 mt-4 mb-5 d-flex justify-content-md-between justify-content-center">
          <router-link to="/partners" class="partners-btn-header partners-btn-header-hover fontsize-small btn-hover-bulgy rounded-pill py-2 px-3">
            ویژه همکاران
          </router-link>
          <button class="call-btn btn-hover-bulgy fontsize-medium rounded-pill bg-none d-md-inline-block d-none text-color-theme py-2 px-3">
            <span class="ml-3">{{homeData.settings.site_phone_header}}</span>
            <svg class="icon" width="20" height="20" stroke="#30504f" stroke-width="1.5">
              <path fill="white" id="Icon_feather-phone-call" d="M16.311,5.564a5.079,5.079,0,0,1,4.013,4.013M16.311,1.5a9.143,9.143,0,0,1,8.076,8.066m-1.016,8.107V20.72a2.032,2.032,0,0,1-2.215,2.032,20.1,20.1,0,0,1-8.767-3.119,19.81,19.81,0,0,1-6.1-6.1A20.1,20.1,0,0,1,3.176,4.731,2.032,2.032,0,0,1,5.2,2.516H8.245a2.032,2.032,0,0,1,2.032,1.747,13.044,13.044,0,0,0,.711,2.855,2.032,2.032,0,0,1-.457,2.144l-1.29,1.29a16.254,16.254,0,0,0,6.1,6.1l1.29-1.29A2.032,2.032,0,0,1,18.77,14.9a13.044,13.044,0,0,0,2.855.711A2.032,2.032,0,0,1,23.372,17.673Z" transform="translate(-2.667 -0.948)"  stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      
      </div>

    </section>
    <!-- <img src="../assets/images/homeBackHeaderpng.png" id="homeHeaderBack" alt=""> -->
  </header>
</template>

<script>
import TopHeader from "./TopHeader";
export default {
  name: "Header",
  components:{
    TopHeader
  },
  mounted() {
    if (window.innerWidth < 768){
      document.querySelector('.partners-btn-header').classList.remove('partners-btn-header-hover');
      document.querySelector('.partners-btn-header').classList.remove('btn-hover-bulgy');
    }
  },
  props:{
    homeData:Object,
  }
}
</script>

<style scoped>
.header{
  min-height: 100vh;
  background-image: url("../assets/images/homeBackHeaderpng.png");
  background-repeat: no-repeat;
}

@media (min-width:1600px){
  .header{
    background-size: 100%;
  }
}
.header-content>div{
  width: 50%;
}
.header-content-btn button span{
  color: white;
}
.header-content-btn button{
  border:1px solid white;
  width: 49%;
  color:white
}
.header-content-btn a{
  background-color:white;
  color: var(--color-theme);
  width: 49%;
  text-align: center;
}
.partners-btn-header{
  background-color: var(--color-theme);
  color: white;
}
.partners-btn-header-hover:hover{
  color: var(--color-theme);
  background: none;
}
.logo-header-resp>div{
  width: 150px;
}
.logo-header-resp>div img{
  width: 100%;
}
.header-title{
  color: white;
}
.colorWhite{
  color: white !important;
}
@media screen and (max-width: 991px){
  .header-content>div{
    width: 60%;
  }
  .header{
     background-size: auto 100%;
     /*background-position-x: center;*/
   }
}
@media (max-width:991px){
  .colorWhite {
    border-radius: 10px;
    -webkit-backdrop-filter: blur(30px);
    backdrop-filter: blur(30px);
    background-color: #ffffff70;
  }
  .colorWhite span {
padding: 8px;
  color: black;
  }
}
@media (max-width:768px){
.header{
  background-image: url("../assets/images/homeBackHeaderMobile.png");
  background-position: center;
}
.header-content-btn a{
  background-color: var(--color-theme);
  color:white;
  width: 49%;
  text-align: center;
}
.mainText {
    border-radius: 10px;
    -webkit-backdrop-filter: blur(30px);
    backdrop-filter: blur(30px);
background-color: #ffffff70;
}
}
@media screen and (max-width: 767px){
  .header-content>div{
    width: 100%;
  }
  .header-title{
    color: var(--color-black);
  }
}
@media screen and (max-width: 500px) {
  
}
.moveToTop{

  height:47vh;
  overflow: hidden;
}
.moveToTop span{
    animation: moveToTop 40s 5s linear infinite ;
  position: relative;
}
@keyframes moveToTop{
from{
  bottom:5vh;
}
to{
  bottom:60vh;
}
}
@media (max-width:768px){
  .logo-header-resp {
margin-top: 8px !important;
  }
}
</style>